import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";
import { appThreadApi, appVectorStoresApi } from "../../config/apiConfig";
import type {
  DeletionStatus,
  NewStoreData,
  NewStoreObj,
  StoreData,
  StoreFileObject,
  StoreFileObjectList,
  StoreList,
  TUploadFileData,
} from "./types";

export const getStores = (): Promise<StoreList> => {
  return appThreadApi
    .get("/v1/vector_stores", {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getLocalStores = (): Promise<StoreList> => {
  return appVectorStoresApi
    .get("/v1/vector_stores", {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const createStore = (postObj: NewStoreObj): Promise<StoreData> => {
  return appThreadApi
    .post("/v1/vector_stores", postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const createLocalStore = (postObj: NewStoreObj): Promise<StoreData> => {
  return appVectorStoresApi
    .post("/v1/vector_stores", postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getStore = (id: string): Promise<StoreData> => {
  return appThreadApi
    .get("/v1/vector_stores/" + id, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getLocalStore = (id: string): Promise<StoreData> => {
  return appVectorStoresApi
    .get("/v1/vector_stores/" + id, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const updateStore = (
  id: string,
  postObj: NewStoreData,
): Promise<StoreData> => {
  return appThreadApi
    .post("/v1/vector_stores/" + id, postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const updateLocalStore = (
  id: string,
  postObj: NewStoreData,
): Promise<StoreData> => {
  return appVectorStoresApi
    .post("/v1/vector_stores/" + id, postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const deleteStore = (id: string): Promise<DeletionStatus> => {
  return appThreadApi
    .delete("/v1/vector_stores/" + id, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const deleteLocalStore = (id: string): Promise<DeletionStatus> => {
  return appVectorStoresApi
    .delete("/v1/vector_stores/" + id, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const createStoreFile = (
  storeId: string,
  fileID: string,
): Promise<StoreFileObject> => {
  return appThreadApi
    .post(
      "/v1/vector_stores/" + storeId + "/files",
      { file_id: fileID },
      {
        withCredentials: false,
        headers: {
          "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
        },
      },
    )
    .then((res) => res.data);
};

export const createLocalStoreFile = (
  storeId: string,
  file: File,
): Promise<TUploadFileData> => {
  const formData = new FormData();
  formData.append("file", file);
  return appVectorStoresApi
    .post("/v1/vector_stores/" + storeId + "/files", formData, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getStoreFiles = (
  storeId: string,
): Promise<StoreFileObjectList> => {
  return appThreadApi
    .get("/v1/vector_stores/" + storeId + "/files?limit=100", {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getLocalStoreFiles = (
  storeId: string,
): Promise<StoreFileObjectList> => {
  return appVectorStoresApi
    .get("/v1/vector_stores/" + storeId + "/files?limit=100", {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getStoreFile = (
  storeId: string,
  fileId: string,
): Promise<StoreFileObject> => {
  return appThreadApi
    .get("/v1/vector_stores/" + storeId + "/files/" + fileId, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getLocalStoreFile = (
  storeId: string,
  fileId: string,
): Promise<StoreFileObject> => {
  return appVectorStoresApi
    .get("/v1/vector_stores/" + storeId + "/files/" + fileId, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const deleteStoreFile = (
  storeId: string,
  fileId: string,
): Promise<DeletionStatus> => {
  return appThreadApi
    .delete("/v1/vector_stores/" + storeId + "/files/" + fileId, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const deleteLocalStoreFile = (
  storeId: string,
  fileId: string,
): Promise<DeletionStatus> => {
  return appVectorStoresApi
    .delete("/v1/vector_stores/" + storeId + "/files/" + fileId, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};
